<template>
  <div class="jobs-create" v-loading="loading">
    <el-form>
      <el-form-item :label="`Диаметр`">
        <el-input v-model="form.dia" type="number"/>
      </el-form-item>
      <el-form-item :label="`Толщина`">
        <el-input v-model="form.width" type="number"/>
      </el-form-item>
      <el-form-item :label="`Дюйм`">
        <el-input v-model="form.inch" type="number"/>
      </el-form-item>

      <div class="jobs-create__buttons">
        <el-button @click="close" v-if="!$route.params.id || $route.params.id === 'new'">Отмена</el-button>
        <el-button v-else type="danger" @click="deleteObject">Удалить</el-button>

        <el-button v-if="!$route.params.id || $route.params.id === 'new'" type="primary" @click="save">Сохранить</el-button>
        <el-button v-else type="primary" @click="edit($route.params.id)">Сохранить</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import firebase from 'firebase';
import work_units from '../../../data/work_units';
// getUnits

export default {
  name: 'Create',
  props: ['lineId'],
  data() {
    return {
      loading: false,
      checked: true,
      createJoinInternal: false,
      options: {
        units: work_units.main,
      },
      form: {
        dia: '',
        width: '',
        inch: ''
      },
    };
  },

  mounted() {
    if (this.$route.params.id) {
      this.form = {
        dia: this.$route.query.dia,
        width: this.$route.query.width,
        inch: Number(String(this.$route.query.inch).replace(',', '.')),
      }

      if (this.$route.params.id === 'new') {
        return
      }
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inch')
        .doc(this.$route.params.id).get().then((response) => {
        const data = response.data();
        this.form = {
          ...data,
        };
      });
    }
  },

  methods: {
    close() {
      this.$router.go(-1);
    },
    deleteObject() {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inch')
          .doc(this.$route.params.id).delete()
          .then((data) => {
            this.$emit('update');
            this.$notify({
              offset: 60,

              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
          });
      });
    },
    async checkDia() {
      const dia = await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inch')
        .where(`dia`, '==', this.form.dia)
        .where(`width`, '==', this.form.width)
        .get();

      let id = null;

      dia.forEach((sub) => {
        id = sub.id;
      })

      return id;
    },
    async edit(id = null) {
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inch').doc(id || this.$route.params.id)
        .update({
          ...this.form,
        }).then((add) => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Сохранено',
          type: 'success',
        });
        setTimeout(() => this.$router.go(-1), 1000);
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    async save() {
      const id = await this.checkDia();
      if(id) {
        this.$confirm(`Вы действительно хотите отредактировать диаметр ${this.form.dia}x${this.form.width}?`,
          `Такой диаметр уже существует`, {
            confirmButtonText: 'Да',
            cancelButtonText: 'Нет',
            type: 'warning',
          }).then(() => {
          return this.edit(id);
        });
        return;
      }



      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inch')
        .add({
          ...this.form,
        }).then((add) => {
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Сохранено',
          type: 'success',
        });
        this.form = {
          name: '',
        };
        setTimeout(() => {
          this.$router.go(-1);
        }, 1000);
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-create {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 42px auto;
  padding-bottom: 128px;

  > > > .el-form-item {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .el-form-item__content {
      display: flex;
      justify-content: flex-start;
      width: 100%;
    }

    .el-form-item__label {
      padding: 0;
    }
  }

  &__buttons {
    margin-top: 28px;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    display: flex;

    &:before {
    }

    &:after {
    }
  }

  .input-line-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex: 1;
  }

  .select-type {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
}

.joint {
  box-shadow: 0px 0px 8px 0px #ccc;
  background: #f7f7f7;
  padding: 10px 20px;
  border-radius: 5px;
}

.in-line {
  display: flex;
}

.jobs-create__buttons {
  position: fixed;
  bottom: 0;
  max-width: 382px;
  width: calc(100% - 40px);
  background: #fff;
  border-top: 1px solid #ccc;
  padding: 10px;
}

.joint-li {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 20px;
}

.li-header {
  display: flex;
  justify-content: space-between;
  flex: 1;
  width: 100%;
}

.link-block {
  font-size: 14px;
  font-weight: bold;
  color: #409EFF;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  position: relative;
  margin-bottom: -26px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Join/Create.vue